import LegalArticle from "../components/LegalArticle";
import PageHero from "../components/PageHero";
import { privacyPolicy } from "../lib/legal";

export default function PrivacyPage() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title={privacyPolicy.title}
        intro="How Qost.ai collects, uses, and protects your data."
      />
      <LegalArticle doc={privacyPolicy} />
    </>
  );
}
